<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item policy_none" style="justify-content: flex-start;">
              <label>保障期间</label>
              <div class="pre-box">
                <div class="">
                  <a-radio-group :disabled="disabledAll" v-model="guapre" @change="e => changeData(e.target.value, 'BZQJa')">
                    <a-radio v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div class="policy_none">
              <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>
            </div>
            <div class="form_item policy_none">
              <label>投保职业</label>
              <div class="right_">
                <div class="check_item s_input" v-for="item in occupationNumberList" :key="item.occupationKind">
                  <label for>
                    {{ item.occupationKind }}
                  </label>
                  <a-input-number :disabled="disabledAll" :min="0" v-model="item.personNum" @change="value => changeData(value, 'TBZYa')"></a-input-number>
                  <span>人</span>
                </div>
                <div class="check_item">
                  <span>总人数：{{ totalNumber }}人</span>
                </div>
              </div>
            </div>
            <div class="form_items">
              <label>是否涉高&nbsp;&nbsp;&nbsp;</label>
              <div class="right_">
                <div class="check_item">
                  <a-radio-group name="radioGroup" :default-value="2" :disabled="disabledAll" v-model="countData.SFSGa" @change="e => changeData(e.target.value, 'SFSGa')">
                    <a-radio :value="2">不涉高</a-radio>
                    <a-radio :value="1">涉高</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_ policy_none">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <p class="p-header">主险</p>
        <!-- 意外身故、残疾 -->
        <div class="form_item">
          <label>意外身故、残疾</label>
          <div class="right_">
            <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" @change="value => changeData(value, 'SWCJ')" v-model="countData.SWCJ">
              <a-select-option v-for="item in SWCJOptions" :key="item.value + 'SWCJ'" :value="item.value"> {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <p class="p-header">附加险</p>
        <div class="flex_">
          <!-- 意外伤害医疗 -->
          <div class="form_item">
            <label>意外伤害医疗</label>
            <div class="right_">
              <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_" v-model="countData.YLFY" @change="value => changeData(value, 'YLFY')">
                <a-select-option v-for="(item, index) in YLFYOptions" :key="item.value + 'YLFY' + index" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 免赔额和赔付比例（仅用于意外医疗） -->
          <div class="form_item">
            <label>免赔额和赔付比例（仅用于意外医疗）</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="countData.YLFY === 0 || disabledAll" v-model="countData.ZFYF" @change="value => changeData(value, 'ZFYF')">
                <a-select-option v-for="(item, index) in ZFYFOptions" :key="item.value + 'ZFYF' + index" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 意外伤害住院津贴 -->
          <div class="form_item">
            <label>意外伤害住院津贴</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="disabledAll" v-model="countData.ZYJT" @change="value => changeData(value, 'ZYJT')">
                <a-select-option v-for="item in ZYJTOptions" :key="item.value + 'ZYJT'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!--猝死 -->
          <div class="form_item">
            <label>猝死</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="disabledAll" v-model="countData.KZSC" @change="value => changeData(value, 'KZSC')">
                <a-select-option v-for="item in KZSCOptions" :key="item.value + 'KZSC'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 客运民航意外 -->
          <div class="form_item">
            <label>客运民航意外</label>
            <div class="right_">
              <a-select placeholder="请选择" :disabled="disabledAll" style="width: 300px" class="select_" v-model="countData.YCXSCa" @change="value => changeData(value, 'YCXSCa')">
                <a-select-option v-for="item in oneSCOptions" :key="item.value + 'YCXSCa'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 客运轨道交通意外 -->
          <div class="form_item">
            <label>客运轨道交通意外</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.SHHLa" @change="value => changeData(value, 'SHHLa')">
                <a-select-option v-for="item in SHHLOptions" :key="item.value + 'SHHLa'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 客运轮船意外 -->
          <div class="form_item">
            <label>客运轮船意外</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.KYLCYW" @change="value => changeData(value, 'KYLCYW')">
                <a-select-option v-for="item in KYLCYWOptions" :key="item.value + 'KYLCYW'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 客运汽车意外 -->
          <div class="form_item">
            <label>客运汽车意外</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.KYQCYW" @change="value => changeData(value, 'KYQCYW')">
                <a-select-option v-for="item in KYQCYWOptions" :key="item.value + 'KYQCYW'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 驾乘意外（非营运车辆） -->
          <div class="form_item">
            <label>驾乘意外（非营运车辆）</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.JCYW" @change="value => changeData(value, 'JCYW')">
                <a-select-option v-for="item in JCYWOptions" :key="item.value + 'JCYW'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn_list">
          <a-button style="margin-bottom:50px;" class="calBtn_" type="primary" @click="goplicy" v-if="!agreementRead"> 完成报价，立即投保</a-button>
          <a-button class="calBtn_" type="primary" @click="countPremiumSum" :disabled="disabledAll">刷新试算</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
let DATA = require('../data').default;
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      guapre: 1,
      //保障期间
      guarantPre: DATA.guarantPre,
      //投保职业及人数
      occupationNumberList: DATA.occupationOptionsLevel,
      premiumSum: 0, //总保费
      // 猝死
      KZSCOptions: DATA.KZSCOptions,
      // 客运民航意外
      oneSCOptions: DATA.oneSCOptions,
      // 客运轨道交通意外
      SHHLOptions: DATA.SHHLOptions,
      //客运轮船意外
      KYLCYWOptions: DATA.KYLCYWOptions,
      //客运汽车意外
      KYQCYWOptions: DATA.KYQCYWOptions,
      //驾乘意外（非营运车辆）
      JCYWOptions: DATA.JCYWOptions,
      // 测算要提交的数据
      countData: {
        BZQJa: 1, //保障期间?
        TBZYa: 0, //投保职业?
        SFSGa: 2, //是否涉高
        // name: '', //投保人名称
        SWCJ: 100000, //意外身故、残疾 1
        YLFY: 0, //意外医疗费用 2
        ZFYF: 1, //免赔额和赔付比例（仅用于意外医疗） 3
        ZYJT: 0, //意外伤害住院津贴 4
        KZSC: 0, //猝死 5
        YCXSCa: 0, //客运民航意外 6
        SHHLa: 0, //客运轨道交通意外 7
        KYLCYW: 0, //客运轮船意外 8
        KYQCYW: 0, //客运汽车意外 9
        JCYW: 0 //驾乘意外（非营运车辆）
      },
      //提交data
      data: {
        riskInfos: [],
        salPolicy: {
          productCode: 'jybguzhuzeren', //产品code
          bracket: 1 //保费期限
        },
        salPolicyExt: {
          isworkheightinvolved: 2
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [] //人数
      },
      planType: 'A',
      creator: '1',
      productCode: '',
      plan: '',
      userParams: ''
    };
  },
  computed: {
    // 意外身故、残疾
    SWCJOptions() {
      let Options = [
        {
          value: 100000,
          name: '10万'
        },
        {
          value: 200000,
          name: '20万'
        },
        {
          value: 300000,
          name: '30万'
        },
        {
          value: 400000,
          name: '40万'
        },
        {
          value: 500000,
          name: '50万'
        },
        {
          value: 600000,
          name: '60万'
        }
      ];
      return Options;
    },
    // 扩展社保范围外医疗费用（含甲乙丙类自付和自费）
    ZFYFOptions() {
      let Options = [
        //免赔额和赔付比例（仅用于意外医疗）
        {
          value: 0.95,
          name: '100免赔，80%赔付'
        },
        {
          value: 1,
          name: '100免赔，85%赔付'
        },
        {
          value: 1.05,
          name: '100免赔，90%赔付'
        },
        {
          value: 1.15,
          name: '100免赔，100%赔付'
        }
      ];
      return Options;
    },
    // 意外伤害医疗
    YLFYOptions() {
      let option = [
        {
          value: 0,
          name: '不附加'
        },
        {
          value: 10000,
          name: '1万'
        },
        {
          value: 20000,
          name: '2万'
        },
        {
          value: 30000,
          name: '3万'
        },
        {
          value: 40000,
          name: '4万'
        },
        {
          value: 50000,
          name: '5万'
        },
        {
          value: 60000,
          name: '6万'
        },
        {
          value: 70000,
          name: '7万'
        },
        {
          value: 80000,
          name: '8万'
        },
        {
          value: 90000,
          name: '9万'
        },
        {
          value: 100000,
          name: '10万'
        },
        {
          value: 110000,
          name: '11万'
        },
        {
          value: 120000,
          name: '12万'
        }
      ];
      return option.filter(item => item.value <= this.countData.SWCJ * 0.2);
    },
    // 意外伤害住院津贴
    ZYJTOptions() {
      let ZYJTOptions = [
        //意外伤害住院津贴 : ZYJT
        {
          value: 0,
          name: '不附加'
        },
        {
          value: 50,
          name: '50元/天'
        },
        {
          value: 100,
          name: '100元/天'
        }
      ];
      return ZYJTOptions;
    },
    // 选的总投保人数
    totalNumber() {
      let num = 0;
      this.occupationNumberList.forEach(e => {
        num += Number(e.personNum);
      });
      return parseInt(num);
    },
    // 险种的数组
    riskInfos() {
      let infos = [
        {
          riskCode: '060099', //意外身故、残疾
          dutyCode: '631001',
          amount: this.countData.SWCJ,
          premiumAmt: 0,
          riskName: `意外身故、残疾`,
          riskAmountDesc: this.countData.SWCJ
        },
        {
          riskCode: '060115', //意外伤害医疗
          dutyCode: '631002',
          amount: this.countData.YLFY,
          premiumAmt: 0,
          riskName: `意外伤害医疗`,
          riskAmountDesc: this.countData.YLFY,
          nonDeductibleRate: this.countData.ZFYF
        },
        {
          riskCode: '060044', //意外伤害住院津贴
          dutyCode: '631042',
          amount: this.countData.ZYJT * 180,
          premiumAmt: 0,
          riskName: `意外伤害住院津贴`,
          riskAmountDesc: `${this.countData.ZYJT}元/天`
        },
        {
          riskCode: '060068', //猝死
          dutyCode: '631068',
          amount: this.countData.KZSC,
          premiumAmt: 0,
          riskName: `猝死`,
          riskAmountDesc: this.countData.KZSC
        },
        {
          riskCode: '060006', //客运民航意外
          dutyCode: '631006',
          amount: this.countData.YCXSCa,
          premiumAmt: 0,
          riskName: `客运民航意外`,
          riskAmountDesc: this.countData.YCXSCa
        },
        {
          riskCode: '060006', //客运轨道交通意外
          dutyCode: '631008',
          amount: this.countData.SHHLa,
          premiumAmt: 0,
          riskName: `客运轨道交通意外`,
          riskAmountDesc: this.countData.SHHLa
        },
        {
          riskCode: '060006', //客运轮船意外
          dutyCode: '631009',
          amount: this.countData.KYLCYW,
          premiumAmt: 0,
          riskName: `客运轮船意外`,
          riskAmountDesc: this.countData.KYLCYW
        },
        {
          riskCode: '060006', //客运汽车意外
          dutyCode: '6310103',
          amount: this.countData.KYQCYW,
          premiumAmt: 0,
          riskName: `客运汽车意外`,
          riskAmountDesc: this.countData.KYQCYW
        },
        {
          riskCode: '060006', //驾乘意外（非营运车辆）
          dutyCode: '6310142',
          amount: this.countData.JCYW,
          premiumAmt: 0,
          riskName: `驾乘意外（非营运车辆）`,
          riskAmountDesc: this.countData.JCYW
        }
      ];
      return infos;
    }
  },
  watch: {
    'countData.YLFY'(val) {
      if (!val) {
        this.countData.ZFYF = 1;
      }
    }
  },
  props: ['disabledAll'],
  mounted() {
    this.$bus.$on('busRiskInfos', data => {
      let obj = this.$lodash.cloneDeep(this.countData);
      
      data.forEach(e => {
        if (e.riskCode == '060099' && e.dutyCode == '631001') obj.SWCJ = e.amount;
        if (e.riskCode == '060115' && e.dutyCode == '631002') obj.YLFY = e.amount;
        if (e.riskCode == '060115' && e.dutyCode == '631002') obj.ZFYF = e.nonDeductibleRate;
        if (e.riskCode == '060044' && e.dutyCode == '631042') obj.ZYJT = e.amount / 180;
        if (e.riskCode == '060068' && e.dutyCode == '631068') obj.KZSC = e.amount;
        if (e.riskCode == '060006' && e.dutyCode == '631006') obj.YCXSCa = e.amount;
        if (e.riskCode == '060006' && e.dutyCode == '631008') obj.SHHLa = e.amount;
        if (e.riskCode == '060006' && e.dutyCode == '631009') obj.KYLCYW = e.amount;
        if (e.riskCode == '060006' && e.dutyCode == '6310103') obj.KYQCYW = e.amount;
        if (e.riskCode == '060006' && e.dutyCode == '6310142') obj.JCYW = e.amount;
      });
      
      this.countData = { ...obj };
    });
    this.$bus.$on('salPolicyExt', data => {
      this.countData.SFSGa = Number(data.isworkheightinvolved) || 2;
      this.form.setFieldsValue({
        countData: this.countData
      })
    });
  },
  beforeDestroy() {
    this.$bus.$off('busRiskInfos');
    this.$bus.$off('salPolicyExt');
  },
  methods: {
    // 去投保
    goplicy() {
      this.$store.commit('setAgreement', true);
    },
    //初始化扩展社保范围外医疗费用
    reactdata() {
      if (this.countData.YLFY == 0) {
        this.countData.ZFYF = 0;
      }
      if (this.occupationNumberList[3].personNum || this.occupationNumberList[4].personNum) {
        this.countData.ZFYF = 0;
      }
    },

    // 改变试算的数据
    changeData(value, param) {
      
      // this.reactdata();
      this.countData[param] = value;
      this.data = {
        riskInfos: this.riskInfos.filter(item => item.amount > 0), //险种信息
        // riskInfos: this.riskInfos,
        salPolicy: {
          planCode: this.plan || this.productCode,
          creator: this.creator,
          productCode: this.productCode, //产品code
          bracket: this.countData.BZQJa.toString(), //保费期限
          groupSize: this.totalNumber
        },
        salPolicyExt: {
          isworkheightinvolved: this.countData.SFSGa.toString()
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          stature: this.countData.SFSGa.toString() //是否高空（2-否，1-是）
          // name: this.countData.name
        },
        premiumBaseDtoList: this.$lodash.cloneDeep(this.occupationNumberList).filter(item => item.personNum > 0) //人数
        // premiumBaseDtoList: this.occupationNumberList, //人数
      };
      let arrData = this.$lodash.cloneDeep(this.data);
      delete arrData['premiumBaseDtoList']; //投保职业人数是不参与下面的计算的
      if (param != 'TBZYa') {
        
        this.$bus.$emit('onRiskInfos', arrData);
      }
    },
    //测算的总价格
    cesuannum(data) {
      var a = {};
      var resultnum = 0;
      this.data.premiumBaseDtoList.forEach(e => {
        a[e.occupationKind] = e.personNum;
      });
      for (const key in a) {
        
        resultnum += a[key] * data[key];
      }
      
      return resultnum.toFixed(2);
    },
    //保费试算
    countPremiumSum(e) {
      e.preventDefault();
      let formData = this.$lodash.cloneDeep(this.data);
      formData.salPolicyHolder.addfifty = '2';
      let num45 = 0 // 四五类职业人数
      let numAll = 0 // 全部人数
      formData.premiumBaseDtoList = formData.premiumBaseDtoList.filter(item => {
        item.occupationKind = Number(item.occupationKind.slice(0, 1));
        numAll += Number(item.personNum)
        if(item.occupationKind == '4' || item.occupationKind == '5') {
          num45 += Number(item.personNum)
        }
        return item;
      });
      this.form.validateFields((err) => {
        if (!err) {
          
          
          if (!this.totalNumber) {
            this.premiumSum = 0;
            this.$message.warning('请选择投保人数');
            return;
          }
          if(num45 > 0 && numAll < 21) {
            this.$message.warning('4-5类职业起保人数需在20人以上。');
            return;
          }
          // let UNname = '天津'
          // if (UNname.indexOf(formData.salPolicyHolder.name)>-1) {
          //   this.$message.warning(
          //     "本产品不承保天津及所辖地区的企业。"
          //   );
          //   return;
          // }
          this.$api.calPremiumEmployer(formData).then(res => {
            if (res.data.success) {
              let data = res.data.content;
              
              this.premiumSum = data.totalPremium;
              // this.premiumSum = this.cesuannum(data);
              // 
              // 
              // this.$bus.$emit("resultPcontent", data);
            } else {
              this.$message.error(res.data.returnMsg + '错误');
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.policy {
  display: none;
}

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}

.pre-box {
  margin-top: 15px;
}

.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}

.risk_ {
  width: 60%;
}

.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}

.flex_ {
  display: flex;
  flex-wrap: wrap;
}

.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}

.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}
</style>
